"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var effector_1 = require("effector");
var redAdapter_1 = require("../redAdapter");
exports.default = (function () {
    return effector_1.createEffect().use(redAdapter_1.getUsersByArea);
});
//# sourceMappingURL=getByArea.js.map